/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { RESOURCE_TYPES } from "@adapptio/lib-core";

/**
 * Returns resource's full path
 *
 * @param basePath Base name
 * @param name Name
 */
export function getResourceFullPath(basePath: string, name: string): string {
	return basePath + "/" + name;
}

/**
 * Returns resource type data
 *
 * @param resourceType Resource type
 * @returns 
 */
export const getResourceTypeData = (resourceType: RESOURCE_TYPES) =>
	((
		{
			[RESOURCE_TYPES.DIRECTORY]: {
				typeMod: "dir",
				icon: "mdi/folder"
			},
			[RESOURCE_TYPES.VIEW]: {
				typeMod: "view",
				icon: "mdi/view-dashboard"
			},
			[RESOURCE_TYPES.ACTION]: {
				typeMod: "action",
				icon: "mdi/motion-play"
			},
			[RESOURCE_TYPES.INTEGRATION]: {
				typeMod: "integration",
				icon: "mdi/connection"
			},
			[RESOURCE_TYPES.ENDPOINT]: {
				typeMod: "endpoint",
				icon: "mdi/hubspot"
			},
			[RESOURCE_TYPES.ROUTES]: {
				typeMod: "routes",
				icon: "mdi/routes"
			},
			[RESOURCE_TYPES.ASSET]: {
				typeMod: "asset",
				icon: "mdi/file"
			},
			[RESOURCE_TYPES.THEME]: {
				typeMod: "theme",
				icon: "mdi/shape-outline"
			},
			[RESOURCE_TYPES.README]: {
				typeMod: "readme",
				icon: "mdi/file-document"
			}
		} as Record<RESOURCE_TYPES, { typeMod: string; icon: string | null }>
	)[resourceType] || {
		typeMod: "unknown",
		icon: "mdi/help"
	});